// initial state
const state = {
  errorMsg: '',
  errorAction: '', //紀錄errorModal按下close之後要額外執行的action
  successMsg: '',
  successAction: '', //紀錄successModal按下close之後要額外執行的action
  mask: false,
  popup: { title: '', content: '' }, // popup標題跟內容
  lightApplyInfo: {
    applyName: '',
    applyPhone: '',
    prayerList: [
      {
        lightTypes: [],
        name: '',
        sex: '',
        birthDate: '',
        birthHour: '',
        phone: '',
        givewayType: '',
        givewayName: '',
        address: {
          county: '',
          town: '',
          detail: '',
        },
        givewayAddress: {
          county: '',
          town: '',
          detail: '',
        },
      },
    ],
    price: 0,
    paymentType: 0,
    payStatus: 0,
    fare: 0,
    serviceId: '',
    policyId: '',
  }, // 線上點燈申請資訊
  banquetApplyInfo: {
    name: '',
    phone: '',
    calculateTypeOfMeat: 'desk',
    calculateTypeOfVegetable: 'desk',
    numberOfPeople: '',
    numberOfVegetarian: '',
  }, // 平安宴申請資訊
  referenceData: {
    countyTownList: [
      {
        countyCode: '',
        countyName: '',
        townList: [
          {
            townCode: '',
            townName: '',
          },
        ],
      },
    ],
  },
  onlineStatus: {
    reposeInfo: {
      enable: true,
      unitPrice: 0,
      discountInfo: {
        price: 0,
        conditionCount: 0,
      },
      remainingAmount: 0,
      serviceInfo: {
        id: '',
        content: '',
      },
    },
    lightInfo: {
      enable: true,
      lightList: [{ type: 0, name: '', price: 0, remainAmount: 0 }],

      serviceInfo: {
        id: '',
        content: '',
      },
    },
  }, // 服務功能設定檔
  orderStatus: '', // 訂單狀態
  bookingList: [
    { orderId: '', serviceType: 0, serviceName: '', applyTime: '' },
  ], // 訂單列表
  bookingInfo: {
    serviceType: '',
    prayerList: [
      {
        name: '',
        sex: '',
        birthDate: '',
        birthHour: '',
        address: '',
        lightType: [0, 1, 2],
      },
    ],
    price: 0,
    paymentType: 0,
    payStatus: 0,
    reposeOrderInfo: { headQuantity: 0, vegetarian: 0 },
  }, // 訂單詳細資訊
};

// getters
const getters = {};

import mutations from './mutations.js';
import actions from './actions.js';

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
